/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Header, BrandColors, LoadingSpinner } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  loadingSpinner: {
    padding: '10px',
  },
  messageWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: '50px',
  },
  overlayContainer: {
    alignItems: 'center',
    backgroundColor: BrandColors.WHITE_85,
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 10,
  },
});

export interface CenteredMessageOverlayProps {
  boundingAreaCssSelector?: string;
  message: string;
  showLoadingSpinner?: boolean;
}

interface OverlayBoundingBox {
  height: string;
  left?: string;
  top?: string;
  width: string;
}

export const CenteredMessageOverlay: React.FC<CenteredMessageOverlayProps> = ({
  showLoadingSpinner,
  message,
  boundingAreaCssSelector,
}) => {
  const [bounds, setBounds] = React.useState<OverlayBoundingBox>({ height: '100%', width: '100%' });
  React.useEffect(() => {
    const baseElement = boundingAreaCssSelector && document.querySelector(boundingAreaCssSelector);
    if (baseElement) {
      const { top, left, height, width } = baseElement.getBoundingClientRect();
      // getBoundingClientRect returns all bounds in numbers, so need to convert to pixels for styling.
      setBounds({
        height: `${height}px`,
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
      });
    }
  }, [boundingAreaCssSelector]);

  return (
    <div className={css(styles.overlayContainer)} id="it-overlayContainer" style={bounds}>
      <div className={css(styles.messageWrapper)}>
        {showLoadingSpinner && (
          <span className={css(styles.loadingSpinner)}>
            <LoadingSpinner theme="tertiary" />
          </span>
        )}
        <Header size={1}>{message}</Header>
      </div>
    </div>
  );
};
